import React, { useEffect, useState, useRef } from "react";
import { Steps, Card, Divider, Button, Space } from "antd";
import { ajaxApi, getMethod } from "@/server/index";
import { getParmUrl } from "@/public/utils";
import _lodash, { get } from "lodash";
import common from "@/public/common";
import styles from "./../index.module.less";
import SupplierInformation from "./supplier-information";
import BasicQualification from "./basic-qualification";
import AuditInformation from "./audit-information";
import { selectDataConversion, jumpUrl } from "./../utils";
import StepsComponents from "../components/steps";
import BrandInfo from "./brand/brand_info";
import { queryAuditInfoApi, baseInfoScsStatusQuery } from "./../service";
import { getCookie } from "@/public/utils";
const { Step } = Steps;
const SupplierInformationEntry = () => {
  // 初始步骤：URL 带 current 参数用之，否则 0；兜底 NaN（getParmUrl 返回 undefined 时 * 1）为 0，避免四个步骤都不渲染白屏
  const [currentNum, setCurrentNum] = useState(() => {
    var init = getParmUrl("current");
    if (init === null || init === undefined || init === "" || isNaN(init * 1)) {
      return 0;
    }
    return init * 1;
  });
  const [supplierInfoData, setSupplierInfoData] = useState({
    basicInformationData: {
      name: "",
      registered_capital: "",
      legal: "",
      money_type: "",
      address: "",
      pro_category: [],
      credit_code: "",
      email: "",
      express_code: "",
      phone: "",
      taxpayer_category: "",
      tax_number: "",
      credit_line_str: "",
      account_period: "",
      purchase_cycle: "",
      is_cross_border: null,
      is_supply_complaint: null,
      estimate_date: "",
      business_tel: "",
      statement_mode: "",
      operation_mode: "",
      save_submit: null,
      review_status: "",
      failure_reason: "",
      sid: getParmUrl("sid") || "",
      supplier_logistic: {
        logistics_address: "",
        logistics_city: "",
        logistics_contactor: "",
        logistics_district: "",
        logistics_province: "",
        logistics_tel: "",
      },
    },
    qualificationData: [],
  });

  const [auditInfo, setAuditInfo] = useState({});
  const [refuseReason, setRefuseReason] = useState({
    review_status: null,
    failure_reason: "",
  });
  // 各步骤子组件 ref，用于触发其保存/提交方法
  const enterpriseRef = useRef(null);
  const brandRef = useRef(null);
  const quaRef = useRef(null);
  // 底部按钮 loading（保存/提交期间禁用，防重复提交）
  const [submitting, setSubmitting] = useState(false);
  const disabled = getParmUrl("stepaction") == "look";
  const getCurrent = (value) => {
    setCurrentNum(value);
  };

  const getSupplierInformation = async () => {
    try {
      const res = await baseInfoScsStatusQuery({
        supplier_code: getCookie("supplier_code"),
      });
      console.log(res);
      if (res.data.code == "0") {
        var auditInfo = {
          ...get(res, "data.data"),
        };
        setAuditInfo(auditInfo);
        // 状态取 supplier_status（erp-srm-sqm-service 新版枚举）：
        // ScsBaseWaitSubmit 基础信息待提交 / ScsBaseWaitAudit 基础信息待审核 → 停步骤0（企业信息）
        // FinalAuditRefused 终审拒绝（QuaReturn 资质退回，基础信息已过）→ 跳步骤3 展示拒绝理由和重新上传入口
        // ScsQuaWaitReplenish 资质待补充 / WaitFirstAudit 待审核 / FinalAuditOK 审核通过 → 跳步骤3
        var supplierStatus = get(res, "data.data.supplier_status");
        var baseInfoStatusList = [
          "ScsBaseWaitSubmit",
          "ScsBaseWaitAudit",
        ];
        if (
          getParmUrl("stepaction") == "look" ||
          baseInfoStatusList.includes(supplierStatus) ||
          (getParmUrl("type") == "change" &&
            baseInfoStatusList.includes(supplierStatus))
        ) {
          setCurrentNum(0);
        } else {
          setCurrentNum(3);
        }
      } else {
        // 查询失败兜底停在步骤0，避免 currentNum 为无效值导致白屏
        setCurrentNum(0);
      }
    } catch (err) {
      console.log(err);
      // 接口异常兜底停在步骤0
      setCurrentNum(0);
    }
  };

  const handleJump = (key) => {
    jumpUrl(key, getParmUrl("sid"), refuseReason.review_status);
  };

  // 触发当前步骤子组件的保存/提交；type: 'save' | 'submit'
  const stepRefs = [enterpriseRef, brandRef, quaRef];
  const handleAction = async (type) => {
    const ref = stepRefs[currentNum];
    if (!ref || !ref.current) return;
    setSubmitting(true);
    try {
      await ref.current[type]();
    } catch (e) {
      // 子组件内部已处理提示，这里仅结束 loading
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(function () {
    if (!["null", null, undefined].includes(getCookie("supplier_code"))) {
      getSupplierInformation();
    } else {
      sessionStorage.setItem(
        "supplierInfoData",
        JSON.stringify(supplierInfoData),
      );
    }
  }, []);

  return (
    <div>
      <Card style={{ width: "100%", marginBottom: "16px" }}>
        <StepsComponents current={0} stepChange={handleJump} />
      </Card>
      <Card style={{ width: "100%" }}>
        <Steps
          onChange={getCurrent}
          current={currentNum}
          items={[
            { title: "填写企业信息" },
            { title: "填写品牌信息" },
            { title: "上传基础资质" },
            { title: "提交视客审核" },
          ]}
        ></Steps>
        <div
          className={styles.errreason}
          style={{
            display:
              supplierInfoData.basicInformationData &&
              supplierInfoData.basicInformationData.review_status === "204" &&
              currentNum === 0
                ? "block"
                : "none",
          }}
        >
          <span style={{ float: "left" }}>失败理由：</span>
          <span
            style={{
              display: "inline-block",
              width: "250px",
              wordWrap: "break-word",
            }}
          >
            {" "}
            {supplierInfoData.basicInformationData &&
            supplierInfoData.basicInformationData.failure_reason
              ? supplierInfoData.basicInformationData.failure_reason
              : "--"}
          </span>
        </div>
        <Divider />
        <div>
          {currentNum === 0 ? (
            <SupplierInformation
              ref={enterpriseRef}
              supplierInfodata={supplierInfoData}
              getCurrent={getCurrent}
              disabled={disabled}
            ></SupplierInformation>
          ) : null}
          {currentNum === 1 ? (
            <BrandInfo
              ref={brandRef}
              getCurrent={getCurrent}
              disabled={disabled}
            ></BrandInfo>
          ) : null}
          {currentNum === 2 ? (
            <BasicQualification
              ref={quaRef}
              getCurrent={getCurrent}
              onStatusRefresh={getSupplierInformation}
              disabled={disabled}
            ></BasicQualification>
          ) : null}
          {currentNum === 3 ? (
            <AuditInformation auditInfo={auditInfo}></AuditInformation>
          ) : null}
        </div>
      </Card>

      {/* 底部固定操作栏：保存/提交通过 ref 触发当前步骤子组件方法，上一步/查看/关闭为纯跳转 */}
      {currentNum !== 3 && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 8,
            padding: "12px 0",
            background: "#fff",
            borderTop: "1px solid #e8e8e8",
            boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.06)",
            zIndex: 100,
          }}
        >
          <Space>
            {/* 步骤0：企业信息 */}
            {currentNum === 0 && !disabled && (
              <Space>
                <Button
                  onClick={() => handleAction("save")}
                  loading={submitting}
                >
                  保存
                </Button>
                <Button
                  type="primary"
                  onClick={() => handleAction("submit")}
                  loading={submitting}
                >
                  下一步，填写品牌信息
                </Button>
              </Space>
            )}
            {currentNum === 0 && disabled && (
              <Button onClick={() => getCurrent(1)}>查看品牌信息</Button>
            )}

            {/* 步骤1：品牌信息 */}
            {currentNum === 1 && !disabled && (
              <Space>
                <Button onClick={() => getCurrent(0)}>上一步</Button>
                <Button
                  onClick={() => handleAction("save")}
                  loading={submitting}
                >
                  保存
                </Button>
                <Button
                  type="primary"
                  onClick={() => handleAction("submit")}
                  loading={submitting}
                >
                  下一步，上传基础资质
                </Button>
              </Space>
            )}
            {currentNum === 1 && disabled && (
              <Space>
                <Button onClick={() => getCurrent(0)}>
                  上一步，查看基础信息
                </Button>
                <Button onClick={() => getCurrent(2)}>
                  下一步，查看基础资质
                </Button>
              </Space>
            )}

            {/* 步骤2：基础资质 */}
            {currentNum === 2 && !disabled && (
              <Space>
                <Button type="primary" onClick={() => getCurrent(1)}>
                  上一步
                </Button>
                <Button
                  onClick={() => handleAction("save")}
                  loading={submitting}
                >
                  保存
                </Button>
                <Button
                  type="primary"
                  onClick={() => handleAction("submit")}
                  loading={submitting}
                >
                  提交审核
                </Button>
              </Space>
            )}
            {currentNum === 2 && disabled && (
              <Button onClick={() => window.history.back()}>
                关闭当前页面
              </Button>
            )}
          </Space>
        </div>
      )}
    </div>
  );
};
export default SupplierInformationEntry;



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/supplierinformationentry/supplier-information-entry.js